angular.module 'zc.projects.reports', [
  'zc.projects'
  'zc.projects.campaigns'
  'zc.commonApi'
]





// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.reports/index.js.coffee